import React from 'react';

/**
 * Text alignment icons.
 *
 * Three toolbars -- the rich text editor, the inline cell editor and the page
 * settings panel -- labelled their alignment buttons with mathematical
 * operators: U+2AF7 TRIPLE NESTED LESS-THAN for align-left, U+2AF6 TRIPLE
 * COLON OPERATOR for centre, U+2AF8 for right. They render as chevrons and
 * dots, nothing about them says "alignment", and the reasonable reading of the
 * row was that only the trigram at the end (Justify) was an alignment control
 * and left, centre and right were missing. They had been there all along.
 *
 * Drawn rather than typed because Unicode has no character meaning "align
 * centre". Each icon is the usual four stacked rules with the ragged edge
 * where that alignment leaves one -- short lines to the right for left
 * aligned, both sides for centred, the left for right aligned, flush for
 * justified. currentColor, so they invert with the button when it is active.
 */

// [x, width] per rule, on a 14-wide viewBox with a 1px inset.
export const ALIGN_LEFT    = [[1, 12], [1, 8], [1, 12], [1, 7]];
export const ALIGN_CENTER  = [[1, 12], [3, 8], [1, 12], [3.5, 7]];
export const ALIGN_RIGHT   = [[1, 12], [5, 8], [1, 12], [6, 7]];
export const ALIGN_JUSTIFY = [[1, 12], [1, 12], [1, 12], [1, 12]];

export const ALIGN_LINES = {
  left: ALIGN_LEFT,
  center: ALIGN_CENTER,
  right: ALIGN_RIGHT,
  justify: ALIGN_JUSTIFY,
};

// The execCommand names the inline cell editor uses, mapped to the same icons.
export const ALIGN_LINES_BY_COMMAND = {
  justifyLeft: ALIGN_LEFT,
  justifyCenter: ALIGN_CENTER,
  justifyRight: ALIGN_RIGHT,
  justifyFull: ALIGN_JUSTIFY,
};

export const ALIGN_LABELS = {
  left: 'Align left',
  center: 'Align centre',
  right: 'Align right',
  justify: 'Justify',
  justifyLeft: 'Align left',
  justifyCenter: 'Align centre',
  justifyRight: 'Align right',
  justifyFull: 'Justify',
};

export function AlignIcon({ lines, size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true" style={{ display: 'block' }}>
      {(lines || ALIGN_LEFT).map(([x, w], i) => (
        <rect key={i} x={x} y={1.5 + i * 3.5} width={w} height="1.5" rx="0.75" fill="currentColor" />
      ))}
    </svg>
  );
}

export default AlignIcon;
